import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetVehicleApprovalRoutingModule } from './asset-vehicle-approval-routing.module';
import { AssetVehicleApprovalDetailsComponent } from './asset-vehicle-approval-details/asset-vehicle-approval-details.component';
import { AssetVehicleApprovalLinkComponent } from './asset-vehicle-approval-link/asset-vehicle-approval-link.component';
import { AssetVehicleApprovalLandingComponent } from './asset-vehicle-approval-landing/asset-vehicle-approval-landing.component';
import { DialogAssetVehicleApprovalComponent } from './dialog-asset-vehicle-approval/dialog-asset-vehicle-approval.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    AssetVehicleApprovalDetailsComponent,
    AssetVehicleApprovalLinkComponent,
    AssetVehicleApprovalLandingComponent,
    DialogAssetVehicleApprovalComponent
  ],
  imports: [
    CommonModule,
    AssetVehicleApprovalRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class AssetVehicleApprovalModule { }
